module.exports = __webpack_public_path__ + "static/Plaak - 43-Pradel-Bold-205TF-f72f06870887f1c24bbbc86f4e77a801.woff2";